import request from '@/api/config/request'

const prex = "api/geral/";

export function getTabSelecoes(tipo) {
    return request({
        url: `${prex}tab_selecoes/${tipo}`,
        method: 'get'
    })
}

export function getCnaeServico(data) {
    return request({
        url: `${prex}cnae_servico`,
        method: 'post',
        data
    })
}

export function getNaturezaQualificacao(naj_codigo) {
    return request({
        url: `${prex}natureza_qualificacao/${naj_codigo}`,
        method: 'get'
    })
}

export function getTributos() {
    return request({
        url: `${prex}tributos`,
        method: 'get'
    })
}